export default "__VITE_ASSET__7ffeedc3__"